import React, { useLayoutEffect, useRef } from 'react';
import classNames from 'classnames';

import styles from './Checkbox.module.scss';

export type CheckboxProps = {
    onChange: (status: boolean) => void;
    disabled?: boolean;
    checked: boolean;
    /** Native indeterminate state (e.g. column “select some”). */
    indeterminate?: boolean;
    /** Sets `aria-label` on the input when there is no visible `label`. */
    ariaLabel?: string;
    className?: string;
    label?: string;
    labelClassName?: string;
    checkboxClassName?: string;
};

const Checkbox = (props: CheckboxProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useLayoutEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = Boolean(props.indeterminate);
        }
    }, [props.indeterminate]);

    const onChange = () => {
        if (!props.disabled) {
            props.onChange(!props.checked);
        }
    };

    const wrapperClasses = classNames(styles.wrapper, props.className);

    const checkboxClasses = classNames(
        styles.checkboxDefault,
        props.checked ? styles.checkboxChecked : styles.checkboxUnchecked,
        props.disabled && styles.checkboxDisabled,
        props.checkboxClassName
    );

    const labelClasses = classNames(styles.label, props.labelClassName);

    return (
        <div className={wrapperClasses}>
            <label className={styles.grid} data-testid='checkbox-label-grid'>
                <input
                    ref={inputRef}
                    type='checkbox'
                    className={checkboxClasses}
                    checked={props.checked}
                    disabled={props.disabled}
                    onChange={onChange}
                    aria-label={props.label ? undefined : props.ariaLabel}
                    data-testid='checkbox'
                />
                {props.label && (
                    <span className={labelClasses} data-testid='label'>
                        {props.label}
                    </span>
                )}
            </label>
        </div>
    );
};

export default Checkbox;
